
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/fixed-deposit",
      function () {
        return require("private-next-pages/products/fixed-deposit/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/fixed-deposit"])
      });
    }
  